export const ADMIN_VERSION = {
  version: 'v2.1',
  updatedAt: '2026.09',
  changelog: '관리자 퍼블 개편 · 비타레터 및 FAQ DB/API 연동 · 관리 기능 개선',
};

export const ADMIN_CHANGELOG: { version: string; date: string; items: string[] }[] = [
  {
    version: 'v2.1',
    date: '2026.09',
    items: [
      '관리자 전체 레이아웃 및 다크 모드 퍼블 디자인 적용',
      '대시보드 지표 · 주간 문의 트렌드 · 서비스별 분포 · 최근 활동 · 알림 팝업 개선 및 목업 데이터 구성',
      'EAP 문의 목록·상세 퍼블 적용 및 이메일 답변·메모 화면 반영 기능 추가',
      '관리자 로그인 화면 퍼블 적용 및 배경·로그인 버튼 색상 보정',
      '비타레터 카테고리·게시글 CRUD, 순서 변경, 페이징 및 이미지 교체 파일 정리 기능 구현',
      '비타레터 카테고리·본문·외부 링크·태그·좋아요·조회수 관련 DB/API 구조 확장',
      'FAQ 카테고리·항목·링크 DB 테이블과 CRUD API 구현',
      'FAQ 카테고리 및 항목 순서 변경, 논리 삭제, display_order 자동 계산 기능 추가',
      'FAQ 관리 퍼블 적용 및 삭제 확인창·빈 목록·드래그 위치·첫 카테고리 선택 오류 수정',
      '관리자 데이터 생성·수정 시간을 한국 표준시와 초 단위 형식으로 통일',
    ],
  },
  {
    version: 'v3.2.0',
    date: '2026.04.25',
    items: [
      '전체 커스텀 훅 성능 최적화 — useCallback / useMemo 전면 적용',
      'useAdBanners: updateBanner · toggleBanner · reorderHomeCta useCallback 래핑, 홈 CTA 목록 useMemo 캐싱',
      'useAdminNotification: sendBrowserNotification · openPanel 의존성 루프 제거 (ref 패턴)',
      '대시보드: STATUS_CONFIG · 목 샘플 데이터 컴포넌트 외부 상수화 — useMemo 내부 재생성 제거',
      'EAP 문의 탭: counts useMemo 캐싱, handleEmailReply · handleCallReply 스테일 클로저 방지',
      '대시보드 차트: ServiceDonut 범례 인라인 style 최적화, ActivityTimeline 콜백 ref 패턴',
      '탭 전환 로직: tabs.findIndex 중복 호출 제거',
    ],
  },
  {
    version: 'v3.1.0',
    date: '2026.04.22',
    items: [
      '로그인 화면 폼 카드 fadeUp 진입 애니메이션 적용',
      '왼쪽 패널 주요 기능 목록 stagger 진입 애니메이션 적용',
      '로그인 성공 시 버튼 확인 피드백 (엠재람드 색상 + ✓ 인증됨 표시)',
      '비밀번호 오류 시 입력칬 shake 애니메이션 연속 실패마다 재실행',
      'EAP 문의 상태(신규/처리중/완료) 뼝지 변경 시 scale pop 피드백 추가',
      '문의 상세 뷰 스와이프로 이전/다음 문의 네비게이션 기능 추가',
      '로그인 화면 영문 타이틀(Admin Console) 제거 · 홈 링크 아이콘 폰(ri-home-line)으로 교체',
      '로그인 하단 홈 링크 문구 참가 ("비타케어 홈으로" → "비타케어 홈으로 돌아가기")',
    ],
  },
  {
    version: 'v3.0.0',
    date: '2026.04.21',
    items: [
      '대시보드 최근 문의에서 해당 기업 클릭 시 문의 상세로 직접 진입 기능 추가 (데스크탑 우측 패널 자동 표시 · 모바일 바텀시트 자동 오픈)',
      '모바일 븷(1024px 미만) 어드민 접근 시 직접 작업 기능 제한 구현 — FAQ 수정 / 뉴스레터 작성 / 광고 업로드 비활성화, 미리보기는 허용',
      '홈 CTA 광고 슬라이더 4개 슬롯을 광고 탭에서 어드민 관리 가능하도록 연결 (순서드래그 ·활성화토글 · 수정 · 미리보기)',
      'FAQ 관리 카테고리 사이드바 너비 확장 (w-44 → w-52/w-56) 및 긴 이름 자동 줄바꾸슸 처리',
      '사이드바 로고 클릭 시 대시보드 탭으로 이동 기능 추가',
      '광고 관리 포치 설명문구 수정 (코묬니티 배너 → 광고 이미지 업로드)',
    ],
  },
  {
    version: 'v2.9.2',
    date: '2026.04.21',
    items: [
      '뉴스레터 상세 페이지 네비게이션바 fixed 포지션 버그 수정',
      '뉴스레터 상세 · 커뮤니티 목록 가로 스크롤 발생 버그 수정',
      '뉴스레터 상세 모바일 하단 고정 바(sticky bar) 제거',
      '뉴스레터 상세 상단 읽기 진행 바 제거',
      '커뮤니티 뉴스레터 상세 페이지 좋아요 하트 파티클 애니메이션 적용',
    ],
  },
  {
    version: 'v2.9.1',
    date: '2026.04.21',
    items: [
      '홈 출처 표기 위치를 상담 만족도(StatCards) 섹션 바로 아래로 이동',
      '출처 텍스트 스타일을 기업EAP 페이지 출처 표기와 동일하게 통일 (text-[10px] md:text-xs)',
      '출처 표기 opacity 미세 조정 (text-gray-300) 및 상단 여백 조정 (mt-6)',
    ],
  },
  {
    version: 'v2.9.0',
    date: '2026.04.25',
    items: [
      '뉴스레터 임시저장(draft) 기능 추가 — 30초 자동저장 · 수동저장 · 이력 복원',
      '발행 이력에서 임시저장 항목 이어서 작성 지원',
      '예약 발행 일정 수정 기능 추가 (빠른 날짜 선택 포함)',
      '예약 현황 요약 배너 — 다음 발행 예정 호수 · 일시 표시',
      '커뮤니티 페이지 970×250 광고 배너 관리 기능 추가',
      '어드민 커뮤니티 탭 제거 (광고 탭으로 통합)',
    ],
  },
  {
    version: 'v2.8.0',
    date: '2026.04.20',
    items: [
      '뉴스레터 발행 관리 전용 탭 신설',
      '구독자 통계 (총 구독자 · 7일 추이 · 경로 분석)',
      '새 호 작성 (즉시 발행 / 예약 발행 · 템플릿 삽입)',
      '발행 이력 관리 (호별 오픈율 · 클릭률 · 이탈 통계)',
    ],
  },
  {
    version: 'v2.7.0',
    date: '2026.04.20',
    items: [
      '대시보드 UI 전면 개편 (비즈니스 스타일)',
      '광고 관리 테이블 뷰로 변경',
      'FAQ 메뉴 순서 조정',
      'PC · 모바일 레이아웃 전체 점검',
    ],
  },
  {
    version: 'v2.6.0',
    date: '2026.04.15',
    items: [
      '광고 노출 기간 설정 기능 추가',
      '광고 클릭 통계 조회 기능 추가',
      '대시보드 주요 지표 카드 추가',
    ],
  },
  {
    version: 'v2.5.0',
    date: '2026.04.10',
    items: [
      '문의 메모 히스토리 기능 추가',
      'CSV 내보내기 기능 추가',
      '문의 상태 관리 개선',
    ],
  },
];

export const ADMIN_FEATURES: { icon: string; label: string; desc: string }[] = [
  { icon: 'ri-dashboard-line',       label: '대시보드',      desc: '주요 지표 한눈에 파악' },
  { icon: 'ri-mail-line',            label: 'EAP 문의',      desc: '문의 접수 · 처리 · 메모' },
  { icon: 'ri-question-answer-line', label: 'FAQ 관리',      desc: '항목 추가 · 수정 · 순서 변경' },
  { icon: 'ri-newspaper-line',       label: '비타레터',      desc: '임시저장 · 예약 발행 · 통계' },
  { icon: 'ri-advertisement-line',   label: '광고 관리',     desc: '광고 이미지 업로드 · 노출 기간 설정' },
];
